import { DataTable } from "../models/data-table.model";
import * as _ from 'lodash'
import { ValidationErrors } from "@angular/forms";
export function convertStringToJson(value?: string) {
  try {
    return JSON.parse(value!);
  } catch (e) {
    return {};
  }
}

export function dataURItoBlob(dataURI: any, type?: string) {
  const byteString = window.atob(dataURI);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  return new Blob([int8Array], { type: type || 'application/octet-stream' });
}

export function mapDataTable(data: any, params: any): DataTable {
  return <DataTable<any>>{
    content: data?.data?.data?.content || [],
    currentPage: params?.page || 0,
    size: params?.size || 10,
    totalElements: data?.data?.data?.totalElements || 0,
    totalPages: data?.data?.data?.totalPages || 0,
    numberOfElements: data?.data?.data?.numberOfElements || 0,
    first: (params?.size || 0) * (params?.page || 0),
  };
}

export function removeParamSearch(params: any) {
  const newParams: any = {};
  _.forEach(params, (value, key) => {
    if (_.isNumber(value) || (!_.isNull(value) && !_.isUndefined(value) && !_.isEmpty(value)) || _.isDate(value)) {
      newParams[key] = value;
    }
  });
  return newParams;
}

export function isEmpty(value: any) {
  return (
    value === null ||
    value === undefined ||
    value === '' ||
    (Array.isArray(value) && value.length === 0) ||
    (!(value instanceof Date) && typeof value === 'object' && Object.keys(value).length === 0)
  );
}

export function isNotEmpty(value: any) {
  return !isEmpty(value);
}

export interface IValidatorMessage {
  key: string;
  required: {
    label: string;
    requiredLength: null | number;
    min: null | number;
    max: null | number;
    maxDateLabel: string | null;
    minDateLabel: string | null;
    count: number | null;
    type: string | null;
  };
}

export function getErrorMessage(errors?: ValidationErrors | null, label: string = '') {
  const objMessage: IValidatorMessage = {
    key: 'EMPTY',
    required: {
      label: label,
      requiredLength: null,
      min: null,
      max: null,
      count: null,
      type: null,
      maxDateLabel: null,
      minDateLabel: null,
    },
  };
  if (!errors) {
    return objMessage;
  }
  const errorKey = Object.keys(errors as object)[0];
  const errorValue: any = errors[errorKey];
  objMessage.key = `validateError.${errorKey}`;
  objMessage.required = { ...objMessage.required, ...errorValue };
  return objMessage;
}

export function removeAscent(str: string) {
  if (str === null || str === undefined) return str;
  str = str.toLowerCase();
  str = str.replace(/[àáạảãâầấậẩẫăằắặẳẵ]/g, 'a');
  str = str.replace(/[èéẹẻẽêềếệểễ]/g, 'e');
  str = str.replace(/[ìíịỉĩ]/g, 'i');
  str = str.replace(/[òóọỏõôồốộổỗơờớợởỡ]/g, 'o');
  str = str.replace(/[ùúụủũưừứựửữ]/g, 'u');
  str = str.replace(/[ỳýỵỷỹ]/g, 'y');
  str = str.replace(/đ/g, 'd');
  return str;
}

/**
 * @summary Chuyển đổi ngày tháng về định dạng chuỗi kí tự. 
 * @ Ví dụ 
 * @ dateStringFormat({ stringDate : '1999/12/31', currentFormat:'yyyy/mm/dd', newFormat:'dd/mm/yyyy' }) => '31/12/1999'
 * @ dateStringFormat({ stringDate : new Date(1999,21,31,15,42,23), newFormat:'dd/mm/yyyy hh:mi:ss' }) => '31/12/1999 15:42:23'
 * @ dateStringFormat({ stringDate : '1999/12/31 15:42:23', currentFormat:'yyyy/mm/dd hh:mi:ss', newFormat:'dd/mm/yyyy hh:mi:ss' }) => '31/12/1999 15:42:23'
 * @ dd : ngày 
 * @ mm : tháng
 * @ yyyy : năm
 * @ hh : giờ
 * @ mi : phút
 * @ ss : giây
 *
 * @param {any} stringDate Ngày tháng truyền vào có thể là kiểu string hoặc kiểu Date
 * @param {string} currentFormat Nếu stringDate là kiểu string, biến này sẽ định nghĩa định dạng của chuỗi kí tự ngày tháng trong biến stringDate
 * @param {string} newFormat Định dạng mong muốn của ngày tháng mà hàm trả ra 
 *
 */
export function dateStringFormat({ stringDate, currentFormat = 'yyyy/mm/dd', newFormat = 'dd/mm/yyyy' }: any) {
  if (stringDate === '' || stringDate === null || typeof stringDate === 'undefined') return '';
  if (typeof stringDate === 'object') {
    newFormat = newFormat.replace('dd', (stringDate.getDate() > 9 ? stringDate.getDate() + '' : '0' + stringDate.getDate()));
    newFormat = newFormat.replace('mm', (stringDate.getMonth() + 1 > 9 ? (stringDate.getMonth() + 1) + '' : '0' + (stringDate.getMonth() + 1)));
    newFormat = newFormat.replace('yyyy', stringDate.getFullYear() + '');
    newFormat = newFormat.replace('hh', stringDate.getHours() > 9 ? stringDate.getHours() + '' : '0' + stringDate.getHours());
    newFormat = newFormat.replace('mi', stringDate.getMinutes() > 9 ? stringDate.getMinutes() + '' : '0' + stringDate.getMinutes());
    newFormat = newFormat.replace('ss', stringDate.getSeconds() > 9 ? stringDate.getSeconds() + '' : '0' + stringDate.getSeconds());
    return newFormat;
  }
  const stringDatePart = stringDate.split(/[-\/._,\\+=!@#$%ˆ&* :a-zA-Z]/g);
  const currentFormatPart = currentFormat.split(/[-\/._,\\+=!@#$%ˆ&* :]/g);
  for (var i = 0; i < stringDatePart.length; i++) {
    if (currentFormatPart[i] === 'dd') newFormat = newFormat.replace('dd', stringDatePart[i].length < 2 ? '0' + stringDatePart[i] : stringDatePart[i]);
    if (currentFormatPart[i] === 'mm') newFormat = newFormat.replace('mm', stringDatePart[i].length < 2 ? '0' + stringDatePart[i] : stringDatePart[i]);
    if (currentFormatPart[i] === 'yyyy') newFormat = newFormat.replace('yyyy', stringDatePart[i]);
    if (currentFormatPart[i] === 'hh') newFormat = newFormat.replace('hh', stringDatePart[i].length < 2 ? '0' + stringDatePart[i] : stringDatePart[i]);
    if (currentFormatPart[i] === 'mi') newFormat = newFormat.replace('mi', stringDatePart[i].length < 2 ? '0' + stringDatePart[i] : stringDatePart[i]);
    if (currentFormatPart[i] === 'ss') newFormat = newFormat.replace('ss', stringDatePart[i].length < 2 ? '0' + stringDatePart[i] : stringDatePart[i]);
  }
  return newFormat;
}

export const helperMapColor = (color: any): any => { // Hàm phụ trợ chuyển đổi giá trị màu (hex, rgb, tên màu) sang định dạng ARGB dùng cho ExcelJS
  if (!color) return { argb: 'FF000000' }; // Nếu không có màu, trả về màu đen mặc định
  const str = String(color).trim(); // Chuyển giá trị màu về chuỗi và loại bỏ khoảng trắng thừa
  if (str.startsWith('#')) { // Nếu là mã màu dạng hex (bắt đầu bằng #)
    let hex = str.replace('#', ''); // Loại bỏ ký tự # khỏi chuỗi
    if (hex.length === 3) { // Nếu là mã hex rút gọn 3 ký tự (vd: #abc)
      hex = hex.split('').map(c => c + c).join(''); // Nhân đôi từng ký tự để thành mã hex đầy đủ 6 ký tự
    }
    return { argb: 'FF' + hex.toUpperCase() }; // Trả về mã ARGB với alpha là FF (không trong suốt)
  }
  if (str.startsWith('rgb')) { // Nếu giá trị màu ở định dạng rgb(...)
    const match = str.match(/\d+/g); // Trích xuất các số trong chuỗi rgb
    if (match && match.length >= 3) { // Nếu có đủ 3 thành phần r, g, b
      const r = parseInt(match[0]).toString(16).padStart(2, '0'); // Chuyển thành phần đỏ sang hex 2 ký tự
      const g = parseInt(match[1]).toString(16).padStart(2, '0'); // Chuyển thành phần xanh lá sang hex 2 ký tự
      const b = parseInt(match[2]).toString(16).padStart(2, '0'); // Chuyển thành phần xanh dương sang hex 2 ký tự
      return { argb: 'FF' + (r + g + b).toUpperCase() }; // Ghép thành mã ARGB hoàn chỉnh
    }
  }
  const colorMap: { [key: string]: string } = { // Bảng ánh xạ tên màu tiếng Anh thông dụng sang mã ARGB
    'red': 'FFFF0000', // Màu đỏ
    'green': 'FF008000', // Màu xanh lá
    'blue': 'FF0000FF', // Màu xanh dương
    'white': 'FFFFFFFF', // Màu trắng
    'black': 'FF000000', // Màu đen
    'yellow': 'FFFFFF00', // Màu vàng
    'gray': 'FF808080', // Màu xám
    'grey': 'FF808080' // Màu xám (cách viết khác)
  };
  return { argb: colorMap[str.toLowerCase()] || 'FF000000' }; // Trả về màu tương ứng trong bảng ánh xạ, mặc định màu đen nếu không tìm thấy
};